import * as React from 'react'

/**
 * @description ContentPenEdit icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { ContentPenEdit } from '@sravni/design-system-icons'
 *
 * <ContentPenEdit />
 * ```
 */
export const ContentPenEdit = React.forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>((props, ref) => (
  <svg ref={ref} data-qa="ContentPenEdit" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g
      clipPath="url(#ContentPenEdit__a)"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m5.147 13.016 8.605-8.605a.833.833 0 0 1 1.177 0l1.397 1.397a.833.833 0 0 1 0 1.177L7.72 15.589a.83.83 0 0 1-.588.244h-2.23v-2.229a.83.83 0 0 1 .245-.588v0ZM12.195 5.967l2.575 2.575" />
    </g>
    <defs>
      <clipPath id="ContentPenEdit__a">
        <path fill="currentColor" transform="translate(.736)" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
))
